var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Payment")]),
    _vm._v(" "),
    _c(
      "form",
      [
        _c("div", { staticClass: "row row-clear-md-4" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateCommissionRate,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v(_vm._s(_vm.clientName) + " Commission"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateCommissionRate.$model,
                        expression: "$v.stateCommissionRate.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "commission_rate", type: "number" },
                    domProps: { value: _vm.$v.stateCommissionRate.$model },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateCommissionRate,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Commission rate",
                    field: _vm.$v.stateCommissionRate,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateDepositPayment,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Deposit payment"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.$v.stateDepositPayment.$model,
                        expression: "$v.stateDepositPayment.$model",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "deposit_payment", type: "number" },
                    domProps: { value: _vm.$v.stateDepositPayment.$model },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.$v.stateDepositPayment,
                          "$model",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Deposit payment",
                    field: _vm.$v.stateDepositPayment,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateNotificationEmail,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Notification Email"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.stateNotificationEmail.$model,
                      expression: "$v.stateNotificationEmail.$model",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "notification_email", type: "email" },
                  domProps: { value: _vm.$v.stateNotificationEmail.$model },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.$v.stateNotificationEmail,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Notification email",
                    field: _vm.$v.stateNotificationEmail,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateNotificationPhone,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Notification Phone"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.stateNotificationPhone.$model,
                      expression: "$v.stateNotificationPhone.$model",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "notification_phone", type: "text" },
                  domProps: { value: _vm.$v.stateNotificationPhone.$model },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.$v.stateNotificationPhone,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Notification phone",
                    field: _vm.$v.stateNotificationPhone,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: _vm.$hasErrorClass(
                  _vm.$v.stateInvoiceTemplate,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Talent Invoice Template"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.$v.stateInvoiceTemplate.$model,
                      expression: "$v.stateInvoiceTemplate.$model",
                      modifiers: { lazy: true },
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "talent_invoice_template", type: "text" },
                  domProps: { value: _vm.$v.stateInvoiceTemplate.$model },
                  on: {
                    change: function ($event) {
                      return _vm.$set(
                        _vm.$v.stateInvoiceTemplate,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    label: "Invoice template",
                    field: _vm.$v.stateInvoiceTemplate,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "ladda-button",
          {
            staticClass: "btn btn-success",
            attrs: { click: _vm.handleSavePaymentSettingsCallback },
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _vm._v(" Save Changes\n    "),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("i", { staticClass: "fa fa-percent" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "input-group-addon" }, [
      _c("i", { staticClass: "fa fa-percent" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }